import { Bug } from 'lucide-react'
import { openFeaturebaseWidget } from '@/components/featurebase-provider'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export function FeaturebaseBugButton() {
  return (
    <Tooltip delayDuration={50}>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          aria-label="Report bug"
          className="text-muted-foreground hover:text-foreground dark:text-muted-foreground dark:hover:text-foreground"
          onClick={openFeaturebaseWidget}
        >
          <Bug className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent variant="panel" sideOffset={6}>
        Report bug
      </TooltipContent>
    </Tooltip>
  )
}
